import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL



export const getProfilePercentage = async payload => {
  let obj = JSON.parse(localStorage.getItem("authUser"))
  // console.log("calling getProfilePercentage"+ obj)
  let UserType = JSON.parse(localStorage.getItem("WWINGS_USER_TYPE"))
 
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: `${obj}`,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }
  console.log(UserType + "Employee")
  if (UserType === "Employee") {
    console.log("I am Employee")
    return await axios.get(`${apiBaseUrl}/employee-profile-percentage`, {
      headers,
    })
  } else {
    console.log("I am Admin")
    return await axios.get(`${apiBaseUrl}/profile-percentage`, {
      headers,
    })
  }
}
